import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Admin, Login } from "./components/Admin";
import { Staff, Login as LoginStaff } from "./components/Staff";

import store from "./redux/store";
import "./App.css";

export const SchoolContext = React.createContext();

const SCHOOLNAME = "Paul Omachi Memorial Schools";
const COLOR = "#9c27b0";

const theme = createTheme({
  palette: {
    primary: {
      main: "rgb(94, 53, 177)",
      dark: "rgb(69, 39, 160)",
      light: "rgb(69, 39, 160)",
      opaque: "rgb(94, 53, 177, .2)",
    },
    secondary: {
      light: "#40d525",
      main: "#3cb027",
      dark: "#29661d",
    },
  },
});
function App() {
  const [auth, setAuth] = useState(false);
  return (
    <SchoolContext.Provider
      value={{
        schoolName: SCHOOLNAME,
        color: COLOR,
      }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Provider store={store}>
            <Routes>
              <Route
                path="/admin/login"
                element={<Login setAuth={setAuth} />}
              />

              <Route path="/admin" element={<Admin auth={auth} />} />
              <Route path="/staff/login" element={<LoginStaff />} />
              <Route path="/staff" element={<Staff />} />
            </Routes>
          </Provider>
        </Router>
      </ThemeProvider>
    </SchoolContext.Provider>
  );
}

export default App;
